<script lang="ts">
	import { Text, type DeviceButtonV2PropsTypes } from '@Shelly/shelly-design-system/index';
	//Component
	import VirtualButton from 'src/components/DevicesSettings/VirtualComponents/Components/VirtualButton.svelte';
	//Types
	import type { Device } from 'src/types/Device';
	import type { VCInterfaceStatus } from 'src/types/VirtualComponents';

	export let device: Device,
		direction: 'open' | 'close' | 'stop',
		size: 'm' | 'l' = 'm',
		statuses: VCInterfaceStatus[],
		title: string = null,
		isLoading = false;

	export let useV2Components = false;
	export let deviceButtonV2Props: Partial<DeviceButtonV2PropsTypes> = { size: 's' };

	const availableState = direction === 'open' ? 'opening' : 'closing';
	let coverState: 'opening' | 'closing' | 'open' | 'closed' | 'stopped';

	$: btnStatusDirection = statuses.find((i) => i.role === direction);
	$: btnStatusStop = statuses.find((i) => i.role === 'stop');
	$: coverState = statuses.find((i) => i.role === 'status')?.event;
</script>

{#if btnStatusDirection?.id}
	{#if btnStatusStop?.id && coverState === availableState}
		<VirtualButton
			{device}
			{size}
			hasDarkIcon
			componentID={btnStatusStop.id}
			value={btnStatusStop.event}
			icon={btnStatusStop.icon}
			{useV2Components}
			{deviceButtonV2Props}
			bind:isLoading
		/>
	{:else}
		<VirtualButton
			{device}
			{size}
			hasDarkIcon
			componentID={btnStatusDirection.id}
			value={btnStatusDirection.event}
			icon={btnStatusDirection.icon}
			{useV2Components}
			{deviceButtonV2Props}
			bind:isLoading
		/>
	{/if}
	{#if title}
		<Text styleType={size === 'm' ? 'body-extra-small' : 'controls-large'} class="mt-s text-bold"
			>{title}</Text
		>
	{/if}
{/if}
